<template>
    <ag-grid-vue
        style="width: 500px; height: 200px; margin-top: 100px"
        class="ag-theme-alpine "
        :column-defs="colDefs"
        :row-data="rowData"
    />
</template>

<script>
import { markRaw } from 'vue';

export default {
    localizationKey: 'nested',
    data() {
        return {
            defaultColDef: {
                editable: false, // read only for now, make-read-only on component too
                suppressMovable: true, // Stop users from being able to rearrange columns.
                lockPinned: true, // Stop users from being able to pin columns.
                sortable: true, // All columns default to being sortable.
                unSortIcon: true, // Ensures the sort icon displays all the time (not just when hovered over).
                flex: 1,
                resizable: true,
                filter: true,
                minWidth: 120,
                headerComponentParams: {},
                menuTabs: [],
                columnDefs: null,
                rowData: null,
                suppressHeaderMenuButton: true,
            },
            gridOptions: markRaw({
                rowHeight: 35, // Specified in pixels.
                // frameworkComponents: {
                //     promoAgIconHeader,
                //     editIconRenderer,
                //     checkboxRenderer,
                //     deleteIconRenderer,
                // },
                // columnTypes: {
                //     numericColumnCustom: agGridUtils.columnTypes.numericColumnCustom,
                // },
                enableCellTextSelection: true,
                enableRangeSelection: true,
                ensureDomOrder: true,
            }),
            colDefs: [
                {
                    headerName: 'username',
                    field: 'username',
                },
                {
                    headerName: 'roles',
                    field: 'roles',
                    minWidth: 300,
                },
            ],
            rowData: [
                {
                    username: 'user 1',
                    roles: 'roles',
                },
                {
                    username: 'user 2',
                    roles: 'roles',
                },
            ],
        };
    },
};
</script>

<style scoped lang="scss"></style>
